export default {
  placeInput: {
    findAPlace: 'Najít místo',
    place: 'Místo',
    addRouteStop: 'Přidat zastávku na trase',
    routePlace: 'Zastávka na trase',
    routeDestination: 'Cíl',
    placeNameRequired: 'Název místa je vyžadován',
    yourLocation: 'Vaše poloha',
    couldNotDetermineYourLocation: 'Vaši polohu se nepodařilo zjistit. Ujistěte se, že jste získali požadovaná oprávnění',
    useYourLocation: 'Použijte svou aktuální polohu',
    removeInput: 'Odstranit místo/vstup',
    directions: 'Instrukce',
    fromYourBrowser: 'Z vašeho zařízení',
    addStartingPlace: 'Přidání výchozího místa',
    startingPlace: 'Výchozí místo',
    openInputOptions: 'Otevřít možnosti vstupu',
    addInput: 'Přidat místo vstupu',
    switchCoords: 'Přepnout souřadnice',
    rawCoordinate: 'Lat,lng hrubé souřadnice',
    fillOrRemoveInput: 'Vyhledejte místo nebo použijte tlačítko na mapě vpravo',
    noPlaceFound: 'Nebyly vráceny žádné výsledky',
    unknownSearchPlaceError: 'Chyba hledání neznámého místa',
    approximateDistance: 'Přibližná vzdálenost po přímce od aktuálního středu mapy',
    couldNotDetermineYourPreciseLocationUsingPreviousLocation: 'Vaši přesnou polohu nebylo možné určit. Místo toho bude použita vaše předchozí poloha',
    pleaseTypeSomething: 'Zadejte prosím něco k vyhledávání',
    toggleDirect: 'Přepněte přímo odsud na další místo',
    clickOnTheMapToSelectAPlace: 'Vyberte místo kliknutím na místo na mapě',
    clickOnTheMapBtnToPickAPlace: 'Kliknutím na toto tlačítko vyberete místo na mapě pro tento vstup.',
    goToDirectionsMode: 'Kliknutím na tlačítko navigace se přepnete do režimu navigace.',
    clickToSearchAndShowResultsOnTheMap: 'Kliknutím zobrazíte výsledky vyhledávání na mapě'
  }
}
